function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.50037 9.5L14.7504 1.25M6.50037 9.5L9.12542 14.75C9.15832 14.8218 9.21115 14.8827 9.27763 14.9253C9.34411 14.968 9.42143 14.9907 9.50042 14.9907C9.57941 14.9907 9.65673 14.968 9.72321 14.9253C9.78968 14.8827 9.84251 14.8218 9.87542 14.75L14.7504 1.25M6.50037 9.5L1.25042 6.875C1.17861 6.8421 1.11776 6.78927 1.0751 6.72279C1.03244 6.65631 1.00977 6.57899 1.00977 6.5C1.00977 6.42101 1.03244 6.34369 1.0751 6.27721C1.11776 6.21074 1.17861 6.15791 1.25042 6.125L14.7504 1.25",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.df5f781a00098867cd2ede8deff5ed44.svg";
export { ForwardRef as ReactComponent };